export default __webpack_public_path__ + "static/media/user-white.261df7ce.svg";